/* template */
<template><div class="container"><mpx-image webp :src="(leftImg)" @tap="goToNy" class="resouce"/><mpx-image webp :src="(rightImg)" @tap="goToDj" class="resouce"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m3d0079a2"}'>
.container
  display flex
  justify-content space-evenly
  margin 40rpx auto
  .resouce
    width 335rpx
    height 171rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m3d0079a2"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./cz-banner.mpx.js?isComponent&outputPath=components%2Fcz-banner3d0079a2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./cz-banner.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fcz-banner3d0079a2%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m3d0079a2"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/cz-banner3d0079a2/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
